module.exports = __webpack_public_path__ + "img/Page4.515f4ea5.png";